/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
// components
import CVCard from '../../../element/CVCard';
import SmallLoading from '../../../element/SmallLoading';
// mui
import { Pagination, Stack } from '@mui/material';

const SearchResultsList = ({
  cvList = [],
  totalPages,
  currentPage,
  smallLoading,
  handlePageChange,
}) => {
  const { t } = useTranslation('global');

  return (
    <section className='searchResultsList col-lg-9'>
      {
        smallLoading
          ? (
            <div className='mt-4 text-center'>
              <SmallLoading />
            </div>
          )
          : (
            cvList?.length > 0
              ? (
                <>
                  {
                    cvList?.map(cvDetails => (
                      <div key={cvDetails.id}>
                        <CVCard cvDetails={cvDetails} />
                      </div>
                    ))
                  }
                  <div className='pagination'>
                    <Stack spacing={2}>
                      <Pagination
                        color='primary'
                        boundaryCount={1}
                        count={totalPages}
                        page={currentPage}
                        onChange={(event, page) => handlePageChange(page)}
                      />
                    </Stack>
                  </div>
                </>
              )
              : (
                <div>
                  <h3 className='text-center'>
                    {t('jobseekerListing.noCvTxt1')}{' '}
                  </h3>
                  <h6 className='text-muted text-center mb-5 mt-3'>
                    {t('jobseekerListing.noCvTxt2')}
                  </h6>
                </div>
              )
          )
      }
    </section>
  );
};

export default SearchResultsList;
